<!---------------------------------new ui---------------------------------------------------->


    <section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Customer Complaints</h1>
    </div>
    </div>
   
    </section>
    
    <section class="content">
    
    <div class="card">
    <div class="card-header">
   
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 25%">
    Customer Name
    </th>

    <th style="width: 22%">
    Customer Department
    </th>

    <th style="width: 15%">
    Complaint
    </th>
    
     
    <th style="width: 5%">
    Date
    </th>

    <th>  
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.customer_name}}
    </a>
    </td>
    
    <td>
    {{c.customer_department}}
    </td>

    
    <td>
    {{c.complaints_or_credit_upgrade_requests[1]}}
    </td>

    <td>
    {{c.complaints_or_credit_upgrade_requests[2]}}
    </td>
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm">
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left">
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
   
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
